<template>
  <div>
    <AllPendingCases :selectedStatuses="statuses" :issues="[]"></AllPendingCases>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const AllPendingCases = defineAsyncComponent(() =>
  import("@/components/pendingCases/AllApprovalPendingCases")
);
export default {
  components: {
    AllPendingCases,
  },
  data() {
    return {
      statuses: ["ACTIVE"],
    };
  },
};
</script>
